import { Component, effect, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { languagesStore } from './store/languages.store';
import { OnboardingStore } from './store/onboarding.store';

@Component({
  imports: [RouterModule],
  selector: 'ctr-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  store = inject(OnboardingStore);
  languageStore = inject(languagesStore);
  translateService = inject(TranslateService);
  title = 'onboarding-ai';

  constructor() {
    effect(() => {
      const actualLanguage = this.languageStore.actualLanguage();

      if (actualLanguage) {
        localStorage.setItem('lan', actualLanguage.prefix);
        const formattedLang = actualLanguage?.prefix.replace('-', '_') as string;
        this.translateService.use(formattedLang);
      }
    });
    effect(() => {
      const fullData = this.store.fullData();
      if (fullData) {
        localStorage.setItem('onboarding-data', JSON.stringify(fullData));
      }
    });
  }
}
